(function() { window.GUID_56dfff4a_8a1e_42d7_871f_924118a0dbad = { getGuid: function() { return "56dfff4a-8a1e-42d7-871f-924118a0dbad"; } }; })();
var ChartAutoRefresh;
(function (ChartAutoRefresh) {
    var refresh = parseInt($('#OneItemRefreshTime').val(), 10);
    if (refresh && refresh > 100) {
        setInterval(function () {
            var canvas = $('#Canvas');
            CompuSport.Ajax.Get(CSParameters.RUrl + "Charts/ChartFullScreenForAutoRefresh/" + CSParameters.SportEventId + window.location.search, null, function (queryResult) {
                canvas[0].innerHTML = queryResult;
            });
        }, refresh);
    }
})(ChartAutoRefresh || (ChartAutoRefresh = {}));

//# sourceMappingURL=ChartAutoRefresh.js.map
